module.exports = __webpack_public_path__ + "media/images/main-logo-9f108e133618b00325b0d06a40aacf33.svg";